import { Grid } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { useContext } from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import AddNote from "./AddNote";
import AnonymousRoute from "./AnonymousRoute";
import { AuthContext } from "./AuthProvider";
import Footer from "./Footer.jsx";
import Header from "./Header.jsx";
import Loader from "./loader/Loader";
import Login from "./Login";
import NotesList from "./NotesList";
import ProtectedRoute from "./ProtectedRoute";
import Register from "./Register";
import { SnackbarProvider } from "./SnackbarProvider";

const App = () => {
  const { user } = useContext(AuthContext);

  return user === "loading" ? (
    <Grid container justifyContent="center" style={{ marginTop: "20px" }}>
      <Grid item>
        <Loader />
      </Grid>
    </Grid>
  ) : (
    <SnackbarProvider>
      <BrowserRouter>
        <CssBaseline />
        <Header />
        <main>
          <Switch>
            <AnonymousRoute redirectTo="/" path="/login" component={Login} />
            <AnonymousRoute
              redirectTo="/"
              path="/register"
              component={Register}
            />
            <ProtectedRoute
              redirectTo="/login"
              path="/note/:id"
              component={AddNote}
            />
            <ProtectedRoute
              redirectTo="/login"
              path="/note"
              component={AddNote}
            />
            <ProtectedRoute
              redirectTo="/login"
              path="/"
              component={NotesList}
            />
          </Switch>
        </main>
        <Footer />
      </BrowserRouter>
    </SnackbarProvider>
  );
};

export default App;
